import axios from 'axios';

const DEFAULT_TIMEOUT = 10000;

export const appClient = axios.create({
  timeout: DEFAULT_TIMEOUT,
});
